export const removeElementsByClassName = (className: string) => {
  const allDomElements = document.querySelectorAll(`.${className}`);

  for (let i = allDomElements.length - 1; i >= 0; i--) {
    const element = allDomElements[i];
    element?.parentNode?.removeChild(element);
  }
};
